import { Box, Button, Group, Image, Title, createStyles } from '@mantine/core';
import { MedplumLink } from '@medplum/react';
import { MemberTable } from './MembersTable';
import { IconPlus } from '@tabler/icons-react';
import SearchInput from '../components/Search';
import FilterIcon  from '../assets/img/filtericon.svg';
import { useNavigate } from 'react-router-dom';

const useStyles = createStyles((theme)=> ({
  flex: {
    display: 'flex',
    justifyContent: 'space-between'
  }

}))

export function UsersPage(): JSX.Element {
  const { classes } = useStyles()
  const navigate = useNavigate();
  return (
    <>
      <Box className={classes.flex}>
      <Title >Users</Title>
      <Button onClick={() => navigate(`/admin/invite`)}><IconPlus style={{
        marginRight: "8px"
      }}/>Invite user</Button>
      </Box>
      <Box sx={{
        display: 'flex',
        minHeight: '50px',
        marginBottom: '32px'
      }}><SearchInput />
       <Image src={FilterIcon} style={{
        width:'50px',
        marginLeft: '24px'
      }}/>
      </Box>
     
      <MemberTable resourceType="Practitioner" fields={['user', 'profile', 'admin', '_lastUpdated']} />
    </>
  );
}
